import { useQuery } from '@apollo/client';

import type {
  UseDegreePlanPropertiesBySlugQuery as Data,
  UseDegreePlanPropertiesBySlugQueryVariables as Variables,
} from 'bundles/degree-home/components/v3-dpm/lib/__queries__/__generated__/useDegreePlanPropertiesBySlug';
import query from 'bundles/degree-home/components/v3-dpm/lib/__queries__/useDegreePlanPropertiesBySlug.graphql';

const useDegreePlanPropertiesBySlug = (slug: string, ssr = true) =>
  useQuery<Data, Variables>(query, {
    variables: { slug },
    skip: !slug,
    context: { clientName: 'gatewayGql' },
    fetchPolicy: 'no-cache',
    ssr,
  });

export default useDegreePlanPropertiesBySlug;
